import React from 'react';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import HeroSection from '../components/sections/HeroSection';
import WhyFlynSection from '../components/sections/WhyFlynSection';
import ProductPreviewSection from '../components/sections/ProductPreviewSection';
import HowItWorksSection from '../components/sections/HowItWorksSection';
import PartnershipsSection from '../components/sections/PartnershipsSection';
import ComparisonSection from '../components/sections/ComparisonSection';
import FAQSection from '../components/sections/FAQSection';
import CTASection from '../components/sections/CTASection';
import Footer from '../components/Footer';

const LandingPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <Navbar />
      
      <main>
        {/* Hero Section */}
        <HeroSection />
        
        {/* Why FLYN Section */}
        <WhyFlynSection />
        
        {/* Product Preview Section */}
        <ProductPreviewSection />
        
        {/* How It Works Section */}
        <HowItWorksSection />
        
        {/* Partnerships Section */}
        <PartnershipsSection />
        
        {/* Comparison Section */}
        <ComparisonSection />
        
        {/* FAQ Section */}
        <FAQSection />
        
        {/* Final CTA Section */}
        <CTASection />
      </main>
      
      <Footer />
    </div>
  );
};

export default LandingPage;
